import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Input, Form, message } from "antd";
import authenticationService from "@services/authentication.service";
import { parseJwt, setProfile, setToken } from "@helpers/utils";

const Login = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  async function login(values) {
    setLoading(true);
    try {
      const res = await authenticationService.login(values);
      const payload = parseJwt(res.data.accessToken);
      setProfile(payload);
      setToken(res.data.accessToken);
      message.success("Welcome");
      history.replace("/dashboard/overview");
    } catch (err) {
      message.error("Action has error",20);
      console.log(err);
      setLoading(false);
    }
  }

  const onSubmit = (values) => {
    console.log("values", values);
    login(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="w-full"
      >
        {/* <span className="text-6xl font-bold mb-7 block">Sign In</span> */}

        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Username is required" }]}
        >
          <Input size="large" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Password is required" }]}
        >
          <Input.Password size="large" />
        </Form.Item>

        <Button
          className="mt-6"
          disabled={loading}
          size="large"
          type="primary"
          block
          htmlType="submit"
        >
          Login
        </Button>
      </Form>
    </>
  );
};

export default Login;
